module.exports = __webpack_public_path__ + "img/NSIA-Assurance-Banque.769776ac.png";